import { useEffect } from "react";
import { useCookies } from "react-cookie";
import { useSearchParams } from "react-router-dom";

const useQueryParamSaver = () => {
  const [searchParams] = useSearchParams();

  const partner = searchParams.get("partner");
  const source = searchParams.get("s");

  const state = searchParams.get("state");
  const offer = searchParams.get("offer");
  const error = searchParams.get("error");

  const errorCode = searchParams.get("code");
  const activationCode = searchParams.get("activationCode");
  const deepLink = searchParams.get("deepLink");

  const [cookies, setCookie] = useCookies();

  useEffect(() => {
    if (errorCode) {
      setCookie("ERRORCODE", errorCode);
    }

    if (partner) {
      setCookie("PARTNER", partner);
    }

    if (offer) {
      setCookie("OFFER", offer, { path: "/subscriptionplus" });
    }

    if (activationCode) {
      setCookie("ACTIVATIONCODE", activationCode);
    }

    if (state) {
      setCookie("STATE", state);
    }

    if (error) {
      setCookie("STATE", error);
    }

    if (deepLink) {
      setCookie("OFFER", deepLink);
    }

    if (cookies.SUBSCRIPTIONPLUS_TRACKING === "true" && source) {
      setCookie("SOURCE", source);
    }
  }, [
    partner,
    offer,
    state,
    error,
    activationCode,
    errorCode,
    source,
    setCookie,
    cookies.SUBSCRIPTIONPLUS_TRACKING,
    deepLink,
  ]);

  return;
};

export default useQueryParamSaver;
